export default __webpack_public_path__ + "static/media/tandem-elk-solid.31306f1a.png";